import ListIcon from '@material-ui/icons/ViewList';

import CustomerDisciplineList from './CustomerDisciplineList';

export default {
    list: CustomerDisciplineList,
    icon: ListIcon,
};
